/// <reference path="Helpers.js"/>
/// <reference path="ChartSetup/ChartSetupUI.js"/>
/// <reference path="GeneralSettings.js"/>
/// <reference path="HTMLHelpers.js"/>
/// <reference path="filteredList.js"/>
/// <reference path="CrossTable2/CrossTable2UI.js"/>

window.Object.dictionarySize = function (obj) {
    var size = 0, key;
    for (key in obj)
        if (obj.hasOwnProperty(key))
            size++;
    return size;
};

(function (sb) {
    sb.HFilterLayout = (sb.HFilterLayout || {});
    sb.HFilterLayout.AdvancedSelections = (sb.HFilterLayout.AdvancedSelections || {});

    // hfilter settings and options
    var mainTree = "#hfilterTree";
    var HFILTER_PREFIX = "hfilterid_";
    var hFilters = null;
	var topHFilterNode = null;
    var levelSettings = null;
    var containerRenderType = { };
    var IsMultiSelect;
    var IsAdvanced;
    var showAncestorsPath = true;
    var isLoaded = false;
    var maxHFilterLevel;

    var dynamicFiltering = 0;
    var dynamicFilteringMoveDisabledToBottom = false;
    var noDataHfiltersMap = {};

    var hasMoreNodesToLoad;

    var useCheckAllTree;
    // hfilter node attributes
    var IsTopNode = 1;
    var IsVisible = 2;
    var IsUserEnabled = 4;
    var IsDefaultSelected = 8;
    var IsBranchExpanded = 16;
	var IsBranchEnabled = 32;
	var HasAccessibleSubNodes = 128;

    // layout types
    var renderTypes = {
        DROPDOWN: "dropdown",
        LISTBOX: "listBox",
        TREE: "tree",
        MULTIBOXES: "multiBoxes",
        MULTIDROPDOWNS: "multiDropdowns"
    };

    var levelModes = {
        Single: 1,
        Multiple: 2,
        Navigation: 3
    };

    // Stores hfilters, layout options and build hfilter controls
    function displayHFilter(hFilterDict, hFilterTitle, options, hasMoreNodes, maxLevel) {
        options = options || {};

        // no hfilters - nothing to do
        if (!hFilterDict || Object.dictionarySize(hFilterDict) < 1)
            return;

        maxHFilterLevel = maxLevel;
        hFilters = hFilterDict;
        hasMoreNodesToLoad = hasMoreNodes;

        if (options.useCheckAllTree != undefined)
            useCheckAllTree = options.useCheckAllTree
        else if (useCheckAllTree != undefined)
            options.useCheckAllTree = useCheckAllTree;

        // for single-control layout: set title
        if (hFilterTitle && !(containerRenderType[mainTree] === renderTypes.MULTIBOXES || containerRenderType[mainTree] === renderTypes.MULTIDROPDOWNS))
            setHFilterTitle(hFilterTitle);
        else // otherwise hide: each level control will use its own
            $(mainTree).siblings(".hFilterName").hide();

        IsMultiSelect = options && options.multi;
		if (mainTree === "#hfilterTree" || mainTree === '#deckHFilterTree') {
            IsAdvanced = options.advanced ? true : false;
            levelSettings = options.levels || Storyboard.GeneralSettings.getHFilterLevels();
		}

		// preselect first available, if necessary
		if (window.ContentType && window.ContentType == Storyboard.Constants.itemTypes.CHART) {
			var selNodes = [];
			for (var hfi in hFilters) {
				if (hFilters.hasOwnProperty(hfi))
					if (hFilters[hfi].Attr & IsDefaultSelected) {
						selNodes.push(hFilters[hfi].HFilterID);
						if (!options.multi) // single select - one option is enough
							break;
					}
			}

			if (selNodes.length < 1) {
				for (var hfi1 in hFilters) {
					if (hFilters.hasOwnProperty(hfi1))
						if (hFilters[hfi1].Attr & IsVisible && hFilters[hfi1].Attr & IsUserEnabled) {
							hFilters[hfi1].Attr |= IsDefaultSelected;
							break;
						}
				}
			}
		}

        var topNode = getTopNode();

        // create control(s) based on selected layout type
        switch (containerRenderType[mainTree]) {
            case renderTypes.DROPDOWN:
                createListBox(IsMultiSelect);
                bindScrollEvent();
                break;

            case renderTypes.LISTBOX: // is sometimes used in export panel
                createListBox(IsMultiSelect === undefined || IsMultiSelect);
                bindScrollEvent();
                // add search/filter
                if (typeof(filteredList) != "undefined") {
                    filteredList.enabled = true;
                    filteredList.searchText = "Search";
                    filteredList.persistSearch = false;
                    filteredList.Initialize($(mainTree).find("select"));
                }
                break;

            case renderTypes.TREE:
                createTree(topNode, options); break;

            case renderTypes.MULTIBOXES:
                createFilterLevels(topNode); break;

            case renderTypes.MULTIDROPDOWNS:
                createLevelDropdowns(topNode); break;
        }
    }

    function bindScrollEvent() {
        if (!hasMoreNodesToLoad) return;
        if (containerRenderType[mainTree] === renderTypes.DROPDOWN)
            $(mainTree + " select").multiselect("widget").find(".ui-multiselect-checkboxes").unbind("scroll").bind("scroll", onHfilterScroll);
        else if (containerRenderType[mainTree] === renderTypes.LISTBOX)
            $(mainTree + " select").unbind("scroll").bind("scroll", onHfilterScroll);
    }

    function unbindScrollEvent() {
        if (containerRenderType[mainTree] === renderTypes.DROPDOWN)
            $(mainTree + " select").multiselect("widget").find(".ui-multiselect-checkboxes").unbind("scroll");
        else if (containerRenderType[mainTree] === renderTypes.LISTBOX)
            $(mainTree + " select").unbind("scroll");
    }

    function onHfilterScroll() {
        // do not load anything
        if (!hasMoreNodesToLoad)
            return;

        var hfilterSelectBox = $(this);
        var scrollPosition = hfilterSelectBox.position().top + hfilterSelectBox.height();

        var lastOption = hfilterSelectBox.find((containerRenderType[mainTree] == renderTypes.DROPDOWN ? "li" : "option") + ":last");
        var lastOptionY = lastOption.height() + lastOption.position().top - 4;

        if (scrollPosition > lastOptionY) {
            // unbind to avoid duplicate calls
            unbindScrollEvent();
            loadMoreListOptions();
        }
    }

    function loadMoreListOptions(forceAll, synchronous) {
        synchronous = !!synchronous;

        if (!hasMoreNodesToLoad)
            return;

        Helpers.perfJSonCall({
            method: "GetHFiltersForList",
            synchronous: synchronous,
            data: {
                startIndex: $(mainTree + " select option").length,
                forceAll: forceAll
            },
            successCallback: addHFiltersToList
        });
    }

    function addHFiltersToList(data) {
        hasMoreNodesToLoad = data.HasMoreNodes;

        // different browsers will enumerate through hFilters differently (e.g. IE will "sort" items by key, so the items' order may change)
        // to avoid reordering - create an array of hFilters (orderedFilters) and sort by SortOrder
        var additionalHFilters = [];
        for (var hfilter in data.HFilterNodes)
            if (data.HFilterNodes.hasOwnProperty(hfilter))
                additionalHFilters.push(data.HFilterNodes[hfilter]);

        additionalHFilters.sort(function (a, b) { return (a.SortOrder < b.SortOrder) ? -1 : ((a.SortOrder > b.SortOrder ? 1 : 0)); });

        var loadedHFilters = data.HFilterNodes;
        for (var hf in loadedHFilters) {
            if (loadedHFilters.hasOwnProperty(hf))
                hFilters[hf] = loadedHFilters[hf];
        }

        if(isDynamicFilteringEnabled())
            performDynamicFiltering();

        var hfOptions = [];
        for (var i = 0; i < additionalHFilters.length; i++) {
            var hFilter = additionalHFilters[i];

            // create an option html for every hfilter that can be used as selection
            if (!isNavigationNode(hFilter) && (hFilter.Attr & IsVisible && hFilter.Attr & IsUserEnabled)) {
                var selected = (hFilter.Attr & IsDefaultSelected) ? "selected='selected'" : "";
                var hfOption = "<option value='" + hFilter.HFilterID + "' " + selected + " "+ getDynamicFilteringAtribute(hFilter.NoData) +" >" + (showAncestorsPath ? hFilter.Ancestors : "") + hFilter.HFilterName + "</option>";
                hfOptions.push(hfOption);
            }
        }

        

        // append all options - check all available controls
        for (var containerId in containerRenderType)
            if (containerRenderType.hasOwnProperty(containerId)) {
                var renderType = containerRenderType[containerId];
                if (renderType === renderTypes.DROPDOWN || renderType === renderTypes.LISTBOX)
                    $(containerId + " > select").append(hfOptions.join(""));
                if (renderType === renderTypes.DROPDOWN)
                    $(containerId + " > select").multiselect("refresh");
            }

        // restore scroll event if there are more nodes that have not been loaded yet
        if (hasMoreNodesToLoad)
            bindScrollEvent();
    }

    // Gets the lowest available hfilter level
    function getMaxLevel() {
        if (!maxHFilterLevel) {
            for (var nodeIX in hFilters) {
                if (hFilters.hasOwnProperty(nodeIX)) {
                    maxHFilterLevel = maxHFilterLevel < hFilters[nodeIX].FilterLevel ? hFilters[nodeIX].FilterLevel : maxHFilterLevel;
                }
            }
        }

        return maxHFilterLevel;
    }

    // Checks if filterLevel uses specified selection mode (Single, Multiple, Navigation)
    function levelModeEquals(filterLevel, mode) {
        levelSettings = levelSettings || Storyboard.GeneralSettings.getHFilterLevels();
        for (var i in levelSettings)
            if (levelSettings.hasOwnProperty(i))
                if (levelSettings[i].depth == filterLevel || levelSettings[i].Depth == filterLevel)
                    return levelSettings[i].selectMode === mode || levelSettings[i].SelectMode === mode;

        return false;
    }

    // Gets filterLevel title to show nest to its control
    function getLevelName(filterLevel) {
        for (var i in levelSettings)
            if (levelSettings.hasOwnProperty(i))
                if (levelSettings[i].depth == filterLevel)
                    return levelSettings[i].name;

        return "";
    }

    // Adds No Selection option to specified sropdown (if it can be used based on level settings)
    function addNoSelection(dropdown, filterLevel, filters) {
        var add = true;
        // check parent hfilters, if there're disabled - don't add No Selection to make user select child node
        for (var i in filters)
            if (filters.hasOwnProperty(i)) {
                if (!(filters[i].Attr & IsUserEnabled) || !(filters[i].Attr & IsVisible)) {
                    add = false;
                    break;
                }
            }

        var disableParent = true;
        // add if parent is enabled and is not a Navigation level, and current level it's not a Navigation level either
        if (add && (!IsAdvanced || !levelModeEquals(filterLevel - 1, levelModes.Navigation)) && (!IsAdvanced || !levelModeEquals(filterLevel, levelModes.Navigation))) {
            dropdown.prepend("<option value='0'>" + Storyboard.GeneralSettings.filterNoSelectionLabel + "</option>");
            disableParent = false; // we'll need to visually 'disable' parent dropdown if No Selection is not present in child dropdown
        }

        var parentDdl = $(mainTree).find("#hfilter_dropdown_" + (filterLevel - 1));
        if (parentDdl.length > 0) {
            if (disableParent)
                parentDdl.siblings(".ui-multiselect").addClass("navigationLevel");
            else
                parentDdl.siblings(".ui-multiselect").removeClass("navigationLevel");
        }
    }

    // renderTypes.MULTIDROPDOWNS
    // Creates a dropdown for each hfilter level, starting with topNode
    function createLevelDropdowns(topNode) {
        if(isDynamicFilteringEnabled())
            $(mainTree).addClass('dynamicFiltering');

        var maxFilterLevel = getMaxLevel();
        createDropDown(topNode.FilterLevel, [topNode], maxFilterLevel);
    }

    // Creates a dropdown for specified filter level
    function createDropDown(filterLevel, hFilterSelection, levels) {
        var selectId = "hfilter_dropdown_" + HTMLHelpers.htmlEncode(filterLevel);

        // current level dropdown
        var currentDdl = $(mainTree).find("#" + selectId);
        // use multi selection if Multi mode is selected globally or for this level
        var multi = IsAdvanced ? levelModeEquals(filterLevel, levelModes.Multiple) : IsMultiSelect;

        // if dropdown does not exist yet create one
        if (currentDdl.length <= 0) {
            $(mainTree).append("<select class='singleSelect'" + "id='" + selectId + "' name='hfilter' " + (multi ? "multiple='multiple'" : "") + "></select>");
            $(mainTree).children("select").css("max-width", "800px");

            $(mainTree).children("select").unbind('multiselectclose').bind('multiselectclose', function () {
                Storyboard.LayoutDesigner.autoUpdateLayoutElements();
            });

            $("#" + selectId).wrap("<div style='display:inline-block'></div>");
            $("#" + selectId).parent().prepend("<span style='display:block'>" + HTMLHelpers.htmlEncode(getLevelName(filterLevel)) + "</span>");

            currentDdl = $(mainTree).find("#" + selectId);
            currentDdl.attr("filterLevel", filterLevel);

            $("#" + selectId).bind('change', function(){
				Storyboard.LayoutDesigner.invokeDynamicFiltering($("#hfilterTree.dynamicFiltering"));
				Storyboard.ReferenceDataFiltering.showHideRefDataSets();
            });
        }

        // populate dropdown with hfilter options
        if (hFilterSelection)
            addFiltersToBox(currentDdl, hFilterSelection);

        // add no selection if current level is not the top one
        if (getTopNode().FilterLevel != filterLevel)
            addNoSelection(currentDdl, filterLevel, hFilterSelection);

        // if no options were selected by this point - set first one as selected
        if (currentDdl.find("option[selected]").length === 0) {
            currentDdl.find("option:first-child").attr("selected", "selected");
        }

        // transform to multiselectbox
        currentDdl.multiselect({
            multiple: multi,
            selectedList: 1,
            classes: (IsAdvanced && levelModeEquals(filterLevel, levelModes.Navigation)) ? "Theme-multiselect navigationLevel" : "Theme-multiselect"
        }).multiselectfilter();

        // get final selections from current level
        var currentSelections = currentDdl.multiselect("getChecked").map(function () { return this.value; }).get();
        // if child level exists
        if (filterLevel + 1 < levels) {
            var filters = getHFilters(currentSelections);
            // remove top node from this list, its children are showed in 1st dropdown already
            var topNodeInd = null;
            for (var i in filters)
                if (filters.hasOwnProperty(i))
                    if ((filters[i].Attr & IsTopNode))
                        topNodeInd = i;

            if (topNodeInd != null)
                filters.splice(topNodeInd, 1);

            // create a dropdown for child level
            createDropDown(filterLevel + 1, filters, levels);

            // load missing children
            if (currentSelections != null && currentSelections.length > 0) {
                currentSelections.forEach(function (currentSelection) {
                    if (currentSelection !== "0") {
                        var checkedHFilter = getHFilter(currentSelection);
                        loadMissingChildren([checkedHFilter], function () {
                            tryUpdateChildDropdown(currentDdl.multiselect("getChecked").map(function () { return this.value; }).get(),
                                parseInt(currentDdl.attr("filterLevel"), 10));
                            GeneralSettings.getFiltersConnectedToHFilters();
                        });
                    }
                });
            }
        }

        // bind select/unselect event
        currentDdl.bind("multiselectclick", function (event, ui) {
            if (ui.checked) {
                if (ui.value !== "0") { // selected valid hfilter - deselect No Selection
                    $(currentDdl).multiselect("widget").find(":checkbox[value='0']").attr("checked", false);
                    $(currentDdl).find("option[value='0']").attr("selected", false);
                } else { // selected No Selection - deselect everything else
                    currentDdl.multiselect("widget").find(":checkbox[value!='0']").attr("checked", false);
                    currentDdl.find("option[value!='0']").attr("selected", false);
                }
            }

            // If user unchecks all items - check No Selection
            if ($(currentDdl).multiselect("widget").find(":checkbox:checked").length === 0)
                $(currentDdl).multiselect("widget").find(":checkbox[value='0']").attr("checked", true);

            // If No Selection is not present: restore selection if user tries to uncheck all (fixes an issue when Parent is disabled)
            if (!ui.checked && currentDdl.multiselect("getChecked").length <= 0) {
                $(currentDdl).multiselect("widget").find(":checkbox[value='" + ui.value + "']").attr("checked", true);
            }

            if (ui.checked && ui.value !== "0") {
                var checkedHFilter = getHFilter(ui.value);
                loadMissingChildren([checkedHFilter], function() {
                    tryUpdateChildDropdown(
                        currentDdl.multiselect("getChecked").map(function () { return this.value; }).get(),
                        parseInt(currentDdl.attr("filterLevel"), 10)
                    );

                    GeneralSettings.fillVariableSubsetList();
                    GeneralSettings.getFiltersConnectedToHFilters();
                });
            } else {
                // update children dropdowns with valid options
                tryUpdateChildDropdown(
                    currentDdl.multiselect("getChecked").map(function() { return this.value; }).get(),
                    parseInt(currentDdl.attr("filterLevel"), 10)
                );

                GeneralSettings.fillVariableSubsetList();
                GeneralSettings.getFiltersConnectedToHFilters();
            }

			Storyboard.LayoutDesigner.invokeDynamicFiltering($("#hfilterTree.dynamicFiltering"));
			Storyboard.ReferenceDataFiltering.showHideRefDataSets();
        });

        currentDdl.bind("multiselectcheckall", function () {
            // uncheck "No Selection""
            $(currentDdl).multiselect("widget").find(":checkbox[value='0']").attr("checked", false);
            $(currentDdl).find("option[value='0']").attr("selected", false);
            $(this).multiselect("update");

            var checkedHFilters = [];
            $(currentDdl).multiselect("widget").find(":checkbox").each(function () {
                if (this.value !== 0) {
                    var checkedHFilter = getHFilter(this.value);
                    if (checkedHFilter) 
                        checkedHFilters.push(checkedHFilter);
                }
            });

            loadMissingChildren(checkedHFilters, function () {
                tryUpdateChildDropdown(
                    currentDdl.multiselect("getChecked").map(function () { return this.value; }).get(),
                    parseInt(currentDdl.attr("filterLevel"), 10)
                );
                GeneralSettings.getFiltersConnectedToHFilters();
            });

            GeneralSettings.fillVariableSubsetList();
            Storyboard.LayoutDesigner.invokeDynamicFiltering($("#hfilterTree.dynamicFiltering"));
            Storyboard.ReferenceDataFiltering.showHideRefDataSets();
        });

        currentDdl.bind("multiselectuncheckall", function () {
            // check "No Selection"
            $(currentDdl).multiselect("widget").find(":checkbox[value='0']").attr("checked", true);
            $(currentDdl).find("option[value='0']").attr("selected", true);
            $(this).multiselect("update");

            // update children dropdowns with valid options
            $(currentDdl).multiselect("widget").find(":checkbox").each(function () {
                tryUpdateChildDropdown(currentDdl.multiselect("getChecked").map(function () { return this.value; }).get(),
                    parseInt(currentDdl.attr("filterLevel"), 10));
            });

            GeneralSettings.fillVariableSubsetList();
            GeneralSettings.getFiltersConnectedToHFilters();
			Storyboard.LayoutDesigner.invokeDynamicFiltering($("#hfilterTree.dynamicFiltering"));
			Storyboard.ReferenceDataFiltering.showHideRefDataSets();
		});

		if (window.ContentType > 0 && window.ContentType == Storyboard.Constants.itemTypes.CHART)
			currentDdl.bind('multiselectclose', function () {
				ChartCreatorSetup.loadContentForDeckSettings();
			});
    }

    // Updates child level options list based on parent level selections
    function tryUpdateChildDropdown(checkedParentList, parentLevel) {
            if (checkedParentList) {
                // remove top node from this list, its children are showed in 1st dropdown already
                checkedParentList = specialCaseTopNode(checkedParentList);
                var filters = getHFilters(checkedParentList);
    
                var childLevel = parentLevel + 1;
                var childDdl = $(mainTree).find("#hfilter_dropdown_" + childLevel);
    
                if (childDdl.length > 0) {
                    // try to keep selected filters
                    var selectedOpts = childDdl.multiselect("getChecked").map(function () { return this.value; }).get();
    
                    addFiltersToBox(childDdl, filters);
                    addNoSelection(childDdl, childLevel, filters);
    
                    childDdl.find("option").removeAttr("selected");
                    if (selectedOpts.length > 0) childDdl.val(selectedOpts);
    
                    if (childDdl.find("option:selected").length === 0) {
                        childDdl.find('option:first-child').attr("selected", "selected");
                    }
    
                    childDdl.multiselect("refresh");
    
                    // it should update its child level as well
                    selectedOpts = childDdl.multiselect("getChecked").map(function () { return this.value; }).get();
                    tryUpdateChildDropdown(selectedOpts, childLevel);
                }
            }
    }

    // Checks if hfilter belongs to navigation-only level
    function isNavigationNode(hFilter) {
        // navigation nodes are only allowed in advanced mode
        // node levels ahve to be adjusted by 1 (except Total node)
        return IsAdvanced && levelModeEquals((hFilter.FilterLevel - (hFilter === getTopNode() ? 0 : 1)), levelModes.Navigation);
    }

    // Sets hfilter container title (for single-control layouts only)
	function setHFilterTitle(name) {
		if (window.ContentType !== Storyboard.Constants.itemTypes.CHART || mainTree !== "#hfilterTree")
			$(mainTree).siblings(".hFilterName").show();
		$(mainTree).siblings(".hFilterName").text(name);
    }

    // Gets hfilter container title (for single-control layouts only)
    function getHFilterTitle() {
        return $(mainTree).siblings(".hFilterName").text();
	}

	function getTopNodes() {
		var topHFilterNodes = [];
		for (var nodeIX in hFilters)
			if (hFilters.hasOwnProperty(nodeIX))
				if (hFilters[nodeIX].Attr & IsTopNode)
                    topHFilterNodes.push(hFilters[nodeIX]);

        topHFilterNodes.sort(function (a, b) { return (a.SortOrder < b.SortOrder) ? -1 : ((a.SortOrder > b.SortOrder ? 1 : 0)); });

        return topHFilterNodes;
	}

    // Gets top node, also stores it in a variable for quick access
    function getTopNode() {
        if (!topHFilterNode) {
            // find by attribute
            for (var nodeIX in hFilters)
                if (hFilters.hasOwnProperty(nodeIX))
                    if (hFilters[nodeIX].Attr & IsTopNode)
                        topHFilterNode = hFilters[nodeIX];

            // or get the first one
            if (!topHFilterNode && hFilters.length > 0)
                topHFilterNode = hFilters[0];
        }

        return topHFilterNode;
    }

    function loadMissingChildren(parentHFilters, callback) {
        var missingChildren = [];
        for (var io = 0; io < parentHFilters.length; io++) {
            var parentHFilter = parentHFilters[io];
            for (var i = 0; i < parentHFilter.ChildNodes.length; i++) {
                var child = getHFilter(parentHFilter.ChildNodes[i].toString());
                if (!child)
                    missingChildren.push(parentHFilter.ChildNodes[i]);
                else if (containerRenderType[mainTree] === renderTypes.MULTIDROPDOWNS ||
                    containerRenderType[mainTree] === renderTypes.MULTIBOXES ||
                    containerRenderType[mainTree] === renderTypes.TREE) { // at least one node found - parent was already selected before
                    missingChildren = [];
                    break;
                }
            }
        }

        if (missingChildren.length > 0) {
            Helpers.perfJSonCall({
                method: "GetHFiltersByIds",
                data: { hfilterIds: missingChildren },
                successCallback: function (loadedHFilters) {
                    for (var hf in loadedHFilters) {
                        if (loadedHFilters.hasOwnProperty(hf))
                            hFilters[hf] = loadedHFilters[hf];
                    }

                    if(isDynamicFilteringEnabled())
                        performDynamicFiltering();

                    if (callback) callback();
                }
            });
        } else if (callback) callback();
    }

    // renderTypes.TREE
    // Creates a tree control
    function createTree(rootNode, options) {
		options = options || { multi: false };
		$(mainTree).append("<ul></ul>");
		var treeTop = $(mainTree).children("ul");

		// creates child nodes (e.g. when existing node is expanded)
		function renderChildren(options) {
			options = options || { parentId: 0, node: null, autonodes: false };

			var allChecked = mainTree.startsWith("#downloadTree", 0) && $("#chkSelectAllExportHF").length > 0 && $("#chkSelectAllExportHF").is(":checked");
            var initSelectedIDs = Array.from(($(mainTree).children('.DUITreeView').attr("data-initselected") || '').split(',') || []).map(Number);


			var nodes = [], cn, i, autonodes = [];
			// parent node was specified - get its children
			if (options.parentId >= 0) {
				for (i in hFilters[options.parentId].ChildNodes)
					if (hFilters[options.parentId].ChildNodes.hasOwnProperty(i)) {
						cn = hFilters[hFilters[options.parentId].ChildNodes[i]];

						if (typeof cn === "object") {
							if (cn.Attr & IsBranchEnabled) {
								var hasAccessibleSubNodes = !((cn.Attr & HasAccessibleSubNodes) && cn.ChildNodes.length);
								if (!hasAccessibleSubNodes) { autonodes.push(cn.HFilterID); }

								var isNavigation = IsAdvanced && levelModeEquals(hFilters[options.parentId].FilterLevel, 3);

								nodes.push({
                                    name: cn.HFilterName,
									value: cn.HFilterID,
                                    checked: !isNavigation && ((cn.Attr & IsDefaultSelected) || (initSelectedIDs.includes(cn.HFilterID)) || (allChecked && (cn.Attr & IsVisible && cn.Attr & IsUserEnabled))),
									disabled: isNavigation || !(cn.Attr & IsVisible && cn.Attr & IsUserEnabled) || (dynamicFiltering === Storyboard.Constants.DynamicFilteringStatus.OnDisableOptionsWithNoData && cn.NoData),
									hidden: (dynamicFiltering === Storyboard.Constants.DynamicFilteringStatus.OnHideOptionsWithNoData && cn.NoData),
									noData: cn.NoData,
									expandable: hasAccessibleSubNodes,
									hiddenBySearch: cn.hiddenBySearch,
									matchedBySearch: cn.matchedBySearch
								});
							}
						}
					}

				if (dynamicFiltering === Storyboard.Constants.DynamicFilteringStatus.OnDisableOptionsWithNoData && dynamicFilteringMoveDisabledToBottom) {
					// move nodata nodes to bottom
					nodes.sort(function (a, b) {
						var diff = !!a.noData - !!b.noData;
						if (diff !== 0) {
							return diff;
						} else {
							return a.value - b.value;
						}
					});
				}
			}

			// render nodes
			if (options.node == null) {
				treeTop.DUITreeView("renderChildNodes", { children: nodes });
			} else {
				treeTop.DUITreeView("renderChildNodes", { node: options.node.children("span"), children: nodes });
			}

			if (options.autonodes) {
				// disabled autonodes. will render entire tree
				for (i in autonodes)
					if (autonodes.hasOwnProperty(i)) {
						var cnodes = [], co, ci;

						for (ci in hFilters[autonodes[i]].ChildNodes)
							if (hFilters[autonodes[i]].ChildNodes.hasOwnProperty(ci)) {
								co = hFilters[hFilters[autonodes[i]].ChildNodes[ci]];
								if (typeof co === "object") {
									if (co.Attr & IsBranchEnabled) {
										hasAccessibleSubNodes = !((co.Attr & HasAccessibleSubNodes) && (co.Attr & IsBranchExpanded) && co.ChildNodes.length);
										cnodes.push({ name: co.HFilterName, value: co.HFilterID, checked: (co.Attr & IsDefaultSelected), disabled: !(co.Attr & IsVisible && co.Attr & IsUserEnabled), expandable: hasAccessibleSubNodes });
									}
								}
							}

						treeTop.DUITreeView("renderChildNodes", { node: treeTop.find("input[value=" + autonodes[i] + "]").parent().children("span"), children: cnodes });
					}
			}
        }

		// initialize tree control
        treeTop.DUITreeView({
            checkAllEnabled: options.useCheckAllTree,
			inlineMenu: false,
			compact: (window.ContentType == Storyboard.Constants.itemTypes.CHART && mainTree === "#hfilterTree" ? false : true),
            singleSelection: (mainTree === "#hfilterTree" || mainTree === '#deckHFilterTree' || (mainTree === "#downloadTreePowerpoint" && !Storyboard.LayoutDesigner.isBulkHFilterExportEnabled())) ? !options.multi : false,
            isSearchable: window.ContentType < 0 && (mainTree === "#hfilterTree" || mainTree === "#downloadTreePowerpoint"),
            isExportPanel: mainTree === "#downloadTreePowerpoint",
			check: function (el) {
				var nodeId = el.val();
				hFilters[nodeId].Attr |= IsBranchExpanded;

				if (window.ContentType == Storyboard.Constants.itemTypes.CROSSTABLE) {
					CrossTable2UI.indicateHierarhicalFilterSelection();
					CrossTable2UI.updateGroupingsTableSizes();
					CrossTable2UI.updateCellsEstimate();
                    CrossTable2UI.loadComparisonPoints();
                    CrossTable2UI.enableDisableHFilterNestingOptions();
				}

				if (window.ContentType == Storyboard.Constants.itemTypes.CHART && el.closest('.hfilterTree').attr('id') != 'deckHFilterTree') {
					ChartCreatorUI.showHideControlsForNoOfSeries();
					ChartCreatorUI.loadComparisonPoints();
					ChartCreatorSetup.controlForManualRecalculateChanged();
					ChartCreatorUI.validateHFilterSelection();
				}

				if (!this.singleSelection)
					disableEnableExportButtons();

                GeneralSettings.fillVariableSubsetList();
                if (mainTree === "#downloadTreePowerpoint")
                    GeneralSettings.getFiltersConnectedToHFilters(undefined, true);
                else GeneralSettings.getFiltersConnectedToHFilters();
				

				Storyboard.LayoutDesigner.invokeDynamicFiltering($("#hfilterTree.dynamicFiltering"));
				Storyboard.ReferenceDataFiltering.showHideRefDataSets();
			}
		});

		// find all selected nodes and names
		// hack to get loading speed up with 10K nodes.
		var selNodes = [], selNames = [];
		for (var hfi in hFilters) {
			if (hFilters.hasOwnProperty(hfi))
				if (hFilters[hfi].Attr & IsDefaultSelected) {
					selNodes.push(hFilters[hfi].HFilterID);
					selNames.push(hFilters[hfi].HFilterName);

					if (!options.multi) // single select - one option is enough
						break;
				}
		}

		$(mainTree).children(".DUITreeView").attr("data-initselected", HTMLHelpers.htmlEncode(selNodes.join(",")));

		function searchHandler(event, treeID) {
			var searchText = $(event.data.treeID).find('.DUITreeSearchInput').val();
			Storyboard.HFilterLayout.searchTree(event.data.treeID, searchText);
            event.preventDefault();
            event.stopPropagation();
		}

		$(mainTree).find('.DUITreeSearchButton').bind('click', {treeID: mainTree}, searchHandler);
		$(mainTree).find('.DUITreeCompactSearch').bind('submit', {treeID: mainTree}, searchHandler);

		var topNodes = getTopNodes();
		var rootNodes = [];
		if (topNodes) {
			topNodes.forEach(function(node) {
				var isNavigation = isNavigationNode(node);
				rootNodes.push({
					name: node.HFilterName,
					value: node.HFilterID,
					checked: !isNavigation && (node.Attr & IsDefaultSelected),
					alwaysShowChildren: node.AlwaysShowChildren,
					alwaysShowLevelBelow: node.AlwaysShowLevelBelow,
					alwaysShowParents: node.AlwaysShowParents,
					alwaysShowSiblings: node.AlwaysShowSiblings,
					disabled: isNavigation || !(node.Attr & IsVisible && node.Attr & IsUserEnabled),
					expandable: !((node.Attr & HasAccessibleSubNodes) && node.ChildNodes.length)
				});
			});
		}
		treeTop.DUITreeView("renderRootNodes", {
			selected: true, children: rootNodes
		});

        // update text info with selected nodes text
        treeTop.DUITreeView("updateCompactText", { names: selNames });

        // bind expand event - new nodes will be created when existing ones are expanded
        treeTop.bind("expanded", function (evt, params) {
            var expandedHFilter = getHFilter(params.value);
            $(params.node).addClass('loading');
            loadMissingChildren([expandedHFilter], function () {
                renderChildren({ parentId: params.value, node: params.node });
                $(params.node).removeClass('loading');
            });
            evt.stopPropagation();
		});

        // apply default selections - it will also create nodes along the path
        if (selNodes.length > 0)
            setSelected(selNodes);
    }

    // renderTypes.DROPDOWN and renderTypes.LISTBOX
    // Creates a single select control with all selectable hfilters as options
    function createListBox(multiple) {
        $(mainTree).append("<select class='singleSelect'" + "id='hFilterList' name='hfilter' " + (multiple ? "multiple='multiple'" : "") + "></select>");
        $(mainTree).children("select").css("max-width", "800px");

        $(mainTree).children("select").unbind('multiselectclose').bind('multiselectclose', function () {
            GeneralSettings.validateMinMaxSelections($('#hfilterTree'));
            Storyboard.LayoutDesigner.autoUpdateLayoutElements();
        });

        $('select',mainTree).bind('change',function(){
            Storyboard.LayoutDesigner.invokeDynamicFiltering($("#hfilterTree.dynamicFiltering"));
            Storyboard.ReferenceDataFiltering.showHideRefDataSets();
            disableEnableRegularFilterIterate(mainTree);
        });

        $('select', mainTree).bind('blur', function () {
            if (mainTree === '#downloadTreePowerpoint')
                GeneralSettings.validateMinMaxSelections($('#downloadTreePowerpoint'), ($('#downloadTreePowerpoint').children('.singleSelect').val() || []).length);
        });

        // different browsers will enumerate through hFilters differently (e.g. IE will "sort" items by key, so the items' order may change)
        // to avoid reordering - create an array of hFilters (orderedFilters) and sort by SortOrder
        var orderedFilters = [];
        for (var hfilter in hFilters)
            if (hFilters.hasOwnProperty(hfilter))
                orderedFilters.push(hFilters[hfilter]);

        orderedFilters.sort(function (a, b) { return (a.SortOrder < b.SortOrder) ? -1 : ((a.SortOrder > b.SortOrder ? 1 : 0)); });
        
        var hfOptions = [];
        for (var i = 0; i < orderedFilters.length; i++) {
            var hFilter = orderedFilters[i];

            // create an option html for every hfilter that can be used as selection
            if (!isNavigationNode(hFilter) && (hFilter.Attr & IsVisible && hFilter.Attr & IsUserEnabled)) {
                var selected = (hFilter.Attr & IsDefaultSelected) ? "selected='selected'" : "";
                var hfOption = "<option value='" + HTMLHelpers.htmlDecode(hFilter.HFilterID) + "' " + selected + " "+ getDynamicFilteringAtribute(hFilter.NoData) +">" + (showAncestorsPath ? HTMLHelpers.htmlDecode(hFilter.Ancestors) : "") + HTMLHelpers.htmlEncode(hFilter.HFilterName) + "</option>";
                hfOptions.push(hfOption);
            }
        }

        // append all options
        $(mainTree + " > select").append(hfOptions.join(""));

        // this filter is really slow when select box contains many filters
        // run only if IE9+ (if less than 100 hfilters)
        if (!mainTree.match("^#downloadTree") && Storyboard.LayoutDesigner) {
            if (hFilters.length > 100)
                return;
            if (document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1")) {
                $(mainTree + " > select")
					.multiselect({ multiple: multiple, selectedList: 1, classes: 'Theme-multiselect' })
					.multiselectfilter();
            }
        }
    }

    function getDynamicFilteringAtribute(noData){
        if(!isDynamicFilteringEnabled())
            return "";
        
        if(noData && dynamicFiltering === Storyboard.Constants.DynamicFilteringStatus.OnDisableOptionsWithNoData) 
            return 'disabled="disabled"';

        if(noData && dynamicFiltering === Storyboard.Constants.DynamicFilteringStatus.OnHideOptionsWithNoData) 
            return 'hidden="hidden"';

        return "";
    }

    // renderTypes.MULTIBOXES
    // Creates a select box for each expanded hfilter level
    function createFilterLevels(topNode) {
        // get a dictionary <expandedLevel, [selected/expanded_node1, selected/expanded_node2]>
        var filterLevels = getExpandedLevels();

        // if nothing is selected/expanded - use top node
        if (filterLevels.length === 0 && topNode.Attr & IsUserEnabled)
            filterLevels.push([topNode]);

        for (var filterLevelIX in filterLevels)
            if (filterLevels.hasOwnProperty(filterLevelIX)) {
                var currentBox = prepareMultiBox(filterLevels[filterLevelIX]);
                createMultiBox(currentBox);
            }
    }

    // Gets a dictionary containing all expanded nodes grouped by filter level
    // <expandedLevel, [selected/expanded_node1, selected/expanded_node2]>
    function getExpandedLevels() {
        var filterLevelArr = [];
        for (var node in hFilters)
            if (hFilters.hasOwnProperty(node)) {
                var currentNode = hFilters[node];
                if (currentNode.Attr & IsBranchExpanded) {
                    // get filterLevel to push node into
                    var currentLevel = filterLevelArr[currentNode.FilterLevel.toString()];

                    // if no level was found, add it to the Array
                    if (!currentLevel) {
                        currentLevel = [];
                        filterLevelArr[currentNode.FilterLevel.toString()] = currentLevel;
                    }

                    currentLevel.push(currentNode);
                }
            }

        return filterLevelArr;
    }

    // Creates a select boxe and adds hfilters for dui.smartselectionbox
    function prepareMultiBox(selectedHFilters) {
        var currentSelectBox = createSelectBox(selectedHFilters); // create a new box or get an existing
        if (!currentSelectBox) {
            removeMultibox(selectedHFilters[0].FilterLevel - 1); // -1 for parent level
            return null;
        }

        // populate the box with hfilters
        var keptSelections = currentSelectBox.DUIsmartSelectBox("selected");
        var noItemsAdded = addFiltersToBox(currentSelectBox, selectedHFilters, keptSelections);
        if (!noItemsAdded) {
            removeMultibox(selectedHFilters[0].FilterLevel - 1); // -1 for parent level
            return null;
        }
        return currentSelectBox;
    }

    // Creates a select box or gets an existing one
    function createSelectBox(currenthFilters) {
        var currenthFilter = null;

        if (currenthFilters.length == 1) {
            currenthFilter = currenthFilters[0];
        }
        else {
            for (var filterIX in currenthFilters)
                if (currenthFilters.hasOwnProperty(filterIX)) {

                    if (currenthFilters[filterIX] && currenthFilters[filterIX].ChildNodes.length > 0) {
                        currenthFilter = currenthFilters[filterIX];
                        continue;
                    }
                }
        }

        if (!currenthFilter)
            return null;

        var selectID = "hfilter_multibox_" + HTMLHelpers.htmlDecode(currenthFilter.FilterLevel);
        var currentSelectBox = $(mainTree).find("#" + selectID);

        if (currentSelectBox.length > 0)
            return currentSelectBox;
        else {
            currentSelectBox = "<div class='hfilter_multibox' style='float:left;'><select id='" + selectID + "' filterLevel='" + HTMLHelpers.htmlDecode(currenthFilter.FilterLevel) + "'></select></div>";
            $(mainTree).append(currentSelectBox);
            return $(mainTree).find("#" + selectID);
        }
    }

    // Transforms select box to dui.smartselectionbox
    function createMultiBox(currentSelectBox) {
        var iconRoot = "./icons/";
        if (window.location.href.toLowerCase().indexOf("tabletools"))
            iconRoot = "../storyboard/icons/";
        else if (window.location.href.toLowerCase().indexOf("reportdistributionmodule"))
            iconRoot = "../storyboard/icons/";

        var filterLevel = parseInt($(currentSelectBox).attr("filterlevel"));

        if (!currentSelectBox.hasClass("DUIsmartSelectBox")) {
            currentSelectBox.DUIsmartSelectBox({
                'filter': true,
                'checkable': true,
                'height': 250,
                'width': 220,
                'singleSelect': !IsMultiSelect && !(IsAdvanced && levelModeEquals(filterLevel, levelModes.Multiple)),
                'customCheckbox': {
                    'def': iconRoot + "arrow2_right_default.png",
                    'checked': iconRoot + "arrow2_right.png",
                    'disabled': iconRoot + "arrow2_right_disabled.png",
                    'hover': iconRoot + "arrow2_right_hover.png"
                }
            });

            currentSelectBox.bind("selected", function () {
                if (!IsMultiSelect && !IsAdvanced) {
                    $(mainTree).find("select[filterLevel!='" + currentSelectBox.attr("filterLevel") + "']").each(function () {
                        $(this).DUIsmartSelectBox("select", "");
                    });
                }
				GeneralSettings.fillVariableSubsetList();
				GeneralSettings.getFiltersConnectedToHFilters();
            });

            currentSelectBox.bind("checked", function (evt, evtValue, evtData) {
                if (!evtData) {
                    var deselectedFilter = getHFilter(evtValue);
                    unsetMultiboxFilters(deselectedFilter);

                    updateMultiBoxes(currentSelectBox.parents(".hfilterTree"), currentSelectBox.attr("filterLevel"));
                } else {
                    var checkedHFilter = getHFilter(evtValue);
                    loadMissingChildren([checkedHFilter], function () {
                        updateMultiBoxes(currentSelectBox.parents(".hfilterTree"), currentSelectBox.attr("filterLevel"));
                    });
                }
            });

            $(currentSelectBox).closest(".hfilter_multibox").prepend("<span class='hfLevelNameLabel' style='display:block'>" + (HTMLHelpers.htmlEncode(getLevelName(filterLevel)) || "") + "</span>");
        } else {
            currentSelectBox.DUIsmartSelectBox("update");
        }
    }

    // Unsets IsBranchExpanded for all hfilters with a specified filter level and its children
    function unsetMultiboxFilters(currentHFilter) {
        currentHFilter.Attr &= ~IsBranchExpanded;

        for (var childIX in currentHFilter.ChildNodes)
            if (currentHFilter.ChildNodes.hasOwnProperty(childIX)) {
                var childNode = currentHFilter.ChildNodes[childIX];
                if (childNode && childNode.Attr & IsBranchExpanded) {
                    unsetMultiboxFilters(childNode);
                }
            }
    }

    // Removes top node from selection
    // (top node is not part of filtering multiselect-boxes or multi-dropdowns)
    function specialCaseTopNode(selectionArr) {
        var topNode = getTopNode();
        var posToRemove;

        for (var selected in selectionArr)
            if (selectionArr.hasOwnProperty(selected)) {
                if (selectionArr[selected] == topNode.HFilterID) {
                    posToRemove = selected;
                    break;
                }
            }

        if (posToRemove)
            selectionArr.splice(posToRemove, 1);

        return selectionArr;
    }

    // Adds hfilters as options to select-element
    function addFiltersToBox(currentSelectBox, selectedHFilters, keptSelections) {
        currentSelectBox.find("option").remove();
        var items = [];
        
        // array with ids which should be kept selected efter binding. assumed to be string array
        keptSelections = keptSelections || [];

        var isNavigation, dataDisabled, dataCheckable, dataChecked, dataSelectableInDdl, dataSelected;

        // selections are "parent" ones, we're populating a box with its children
        for (var hfIndex in selectedHFilters)
            if (selectedHFilters.hasOwnProperty(hfIndex)) {

                var selectedHFilter = selectedHFilters[hfIndex];

                // Total node is shown in the same select box as its direct children - add it
                if (selectedHFilter.Attr & IsTopNode) {
                    isNavigation = isNavigationNode(selectedHFilter);
                    dataDisabled = ((selectedHFilter.Attr & IsUserEnabled) && (selectedHFilter.Attr & IsVisible) && !isNavigation) ? "" : "data-selectDisabled='true'";

                    if (dataDisabled === "" || containerRenderType[mainTree] !== renderTypes.MULTIDROPDOWNS) {
                        dataChecked = selectedHFilter.Attr & IsDefaultSelected ? "data-selected='true'" : "";
                        dataCheckable = "data-checkable='false'";
                        dataSelectableInDdl = (containerRenderType[mainTree] === renderTypes.MULTIDROPDOWNS && isNavigation) ? "disabled" : "";

                        items.push("<option value='" + selectedHFilter.HFilterID + "' " + dataDisabled + " " + dataChecked + " " + dataCheckable + " " + 
                            dataSelectableInDdl + ">" + selectedHFilter.HFilterName + "</option>");
                    }
                }

                // loop through children and create a option for each that can be used
                for (var childIX in selectedHFilter.ChildNodes)
                    if (selectedHFilter.ChildNodes.hasOwnProperty(childIX)) {
                        // if branch is disabled don't create it
                        var child = hFilters[selectedHFilter.ChildNodes[childIX]];
                        if (!child || !(child.Attr & IsBranchEnabled))
                            continue;

                        isNavigation = isNavigationNode(child);
                        dataDisabled = ((child.Attr & IsUserEnabled) && (child.Attr & IsVisible) && !isNavigation) ? "" : "data-selectDisabled='true'";
                        dataChecked = child.Attr & IsBranchExpanded ? "data-checked='true' selected='selected'" : "";
                        dataSelected = (child.Attr & IsDefaultSelected) || (indexOfShim(keptSelections, "" + child.HFilterID) >= 0) ? "data-selected='true' selected='selected'" : "";
                        dataSelectableInDdl = (containerRenderType[mainTree] === renderTypes.MULTIDROPDOWNS && child.ChildNodes.length === 0 && isNavigation) ? "disabled" : "";

                        var hasAccessibleSubNodes = (child.Attr & IsBranchEnabled) && child.ChildNodes.length;

                        var dataCheckedDisabled = hasAccessibleSubNodes ? "" : "data-checkedDisabled='true'";
                        if (child.ChildNodes.length === 0)
                            dataCheckedDisabled = "data-checkable='false'";

                        items.push("<option value='" + HTMLHelpers.htmlDecode(child.HFilterID) + "' " + dataDisabled + " " + dataSelected + " " + dataChecked + " " + dataCheckedDisabled + " " 
                            + dataSelectableInDdl + " >" + HTMLHelpers.htmlDecode(child.HFilterName) + "</option>");
                    }
            }

        $(currentSelectBox).append(items.join(""));
        
        if(isDynamicFilteringEnabled())
            Storyboard.DynamicFiltering.processSelectBoxWithStandardParser($(currentSelectBox), getLoadedNoDataNodes())

        return items.length;
    }

    // to deal with ie 7/8 that doesn't support Array.indexOf.
    // the correct way to fix this should be to implement the method as described at
    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/indexOf#Compatibility
    // but it brought on a whole new wave of bugs in ie when iterating empty arrays
    function indexOfShim(arr, searchElement) {
        if (!arr)
            return -1;
        else if (arr.indexOf)
            return arr.indexOf(searchElement);
        else {
            for (var i = 0; i < arr.length; i++)
                if (arr[i] === searchElement)
                    return i;

            return -1;
        }
    }

    // Destroys smatrselectboxes and removes select boxes for levels below specific hfilter level
    function removeMultibox(filterLevel) {
        var multiboxes = $(mainTree).find("select");
        multiboxes.each(function () {
            if ($(this).attr("filterLevel") > filterLevel) {
                $(this).siblings(".hfLevelNameLabel").remove();
                $(this).DUIsmartSelectBox("destroy");
                $(this).remove();
            }
        });
    }

    // Refreshes content of multiboxes
    function updateMultiBoxes(parentTree, filterLevel) {
        if (parentTree.length > 0)
            mainTree = parentTree;

        var multiboxes = $(mainTree).find("select");
        multiboxes.each(function () {
            if ($(this).attr("filterLevel") >= filterLevel) {
                var selectionArr = $(this).DUIsmartSelectBox("checked");
                // update if there's something to show
                if (selectionArr && selectionArr.length > 0) {
                    var hfilters = getHFilters(selectionArr);

                    for (var i = 0; i < hfilters.length; i++) {
                        hfilters[i].Attr |= IsBranchExpanded;
                    }

                    var multiBox = prepareMultiBox(hfilters);
                    if (multiBox)
                        createMultiBox(multiBox);
                } else // otherwise remove
                    removeMultibox($(this).attr("filterLevel"));
            }
        });
    }

    // Used in export panel: sets nodeIDs as selected in treeID container
    function setSelected(nodeIDs, treeID) {
        if (treeID)
            mainTree = treeID;

        $(mainTree + " select option").removeAttr("selected");
        $(mainTree + " input[type=checkbox]").removeAttr("checked");

        // for select controls just set options attribute
        if (containerRenderType[mainTree] === renderTypes.DROPDOWN ||
            containerRenderType[mainTree] === renderTypes.LISTBOX ||
            containerRenderType[mainTree] === renderTypes.MULTIBOXES) {
            nodeIDs.map(function (nodeID) {
                var optionElement = document.querySelector(mainTree + " select option[value='" + nodeID + "']");
                if (optionElement) {
                    optionElement.setAttribute("selected", "selected");
                    optionElement.selected = true;
                }
            });
        }

        // for tree
        if (containerRenderType[mainTree] === "tree") {
            var selNames = [];
            var to = $(mainTree).children("ul");

            for (var nodeIX in nodeIDs)
                if (nodeIDs.hasOwnProperty(nodeIX)) {
                    var nodeID = nodeIDs[nodeIX];
                    var nodeInput = $(document.querySelector(mainTree + " input[value='" + nodeID + "']"));

                    // if node already exists - set checked
                    if (nodeInput.length > 0) {
                        nodeInput.first().attr("checked", "checked");
                    } else { // otherwise expand ancestors first
                        var roots = [];
                        getParentPath(nodeID, roots);
                        roots = roots.reverse();
                        for (var i = 0; i < roots.length; i++) {
                            to.DUITreeView('expandNode', $(document.querySelector(mainTree + " input[value='" + roots[i] + "']")).parent("li"));
                        }
                        var optionElement = document.querySelector(mainTree + " input[value='" + nodeID + "']");
                        if (optionElement) {
                            optionElement.setAttribute("checked", "checked");
                            optionElement.checked = true;
                        }
                    }

                    // store hfilter name
                    var hfilter = getHFilter(nodeID);
                    if (hfilter)
                        selNames.push(hfilter.HFilterName);
                }

            // and display selected names in compact info
            $(mainTree).children('.DUITreeView').attr("data-initselected", HTMLHelpers.htmlEncode(nodeIDs.join(",")));
            to.DUITreeView("updateCompactText", { names: selNames });
		}

		if (window.ContentType == Storyboard.Constants.itemTypes.CROSSTABLE) {
			CrossTable2UI.indicateHierarhicalFilterSelection();
			CrossTable2UI.updateGroupingsTableSizes();
			CrossTable2UI.updateCellsEstimate();
		}
		Storyboard.ReferenceDataFiltering.showHideRefDataSets();
	}
	
	function setSelectedBySelectedLevels(treeID) {
		loadAllMissingNodes(function () {
			var selectedLevels = [];
			var selectedIds = getSelectedIds(treeID);

			for (var nodeIx in selectedIds) {
				var hfId = selectedIds[nodeIx];
				if (hFilters.hasOwnProperty(hfId)) {
					if (selectedLevels.indexOf(hFilters[hfId].FilterLevel) == -1)
						selectedLevels.push(hFilters[hfId].FilterLevel);
				}
			}

			var nodesToSelect = [];
			for (var nodeId in hFilters) {
				if (hFilters.hasOwnProperty(nodeId)) {
					var hfn = hFilters[nodeId];
					if (selectedLevels.indexOf(hfn.FilterLevel) > -1 && hfn.Attr & IsVisible && hfn.Attr & IsUserEnabled)
						nodesToSelect.push(nodeId);
				}
			}

			Storyboard.HFilterLayout.setSelected(nodesToSelect, treeID);
		});
	}

	function setSelectedBySelectedSiblings(treeID) {
		var selectedIds = getSelectedIds(treeID);
		var nodesToSelect = [];

		function getParent(hfId) {
			for (var hfIx in hFilters) {
				if (hFilters.hasOwnProperty(hfIx)) {
					var filt = hFilters[hfIx];
					if ($.inArray(parseInt(hfId), filt.ChildNodes) > -1)
						return filt;
				}
			}
			return null;
		}

		for (var nodeIx in selectedIds) {
			var hfId = selectedIds[nodeIx];

			if (hFilters.hasOwnProperty(hfId)) {
				var parent = getParent(hfId);
				if (parent) {
					for (var childIx in parent.ChildNodes) {
						var childId = parent.ChildNodes[childIx];
						var hfn = hFilters[childId];
						if (nodesToSelect.indexOf(childId) == -1 && hfn.Attr & IsVisible && hfn.Attr & IsUserEnabled)
							nodesToSelect.push(childId.toString());
					}
				}
			}
		}

		Storyboard.HFilterLayout.setSelected(nodesToSelect, treeID);
	}

	function setSelectedByXLevelsDown(treeID, levelOffset) {

		function getDescendantIds(hfilter, levelOffset) {
			var ids = [];			
			if (levelOffset == 1) {
				for (var childIx in hfilter.ChildNodes)
					ids.push(hfilter.ChildNodes[childIx].toString());
			} else if (levelOffset > 1) {
				for (var childIx1 in hfilter.ChildNodes) {
					var childHFilter = getHFilter(hfilter.ChildNodes[childIx1].toString());
					var descIds = getDescendantIds(childHFilter, levelOffset - 1);

					for (var ix in descIds) {
						if (ids.indexOf(descIds[ix]) == -1)
							ids.push(descIds[ix]);
					}
				}
			}

			return ids;
		}

		loadAllMissingNodes(function () {
			var selectedIds = getSelectedIds(treeID);
			var nodesToSelect = [];

			for (var nodeIx in selectedIds) {
				var selectedId = selectedIds[nodeIx]
				var hfilter = getHFilter(selectedId);

				if (nodesToSelect.indexOf(selectedId) == -1 && hfilter.Attr & IsVisible && hfilter.Attr & IsUserEnabled)
					nodesToSelect.push(selectedId);
				
				var descIds = getDescendantIds(hfilter, levelOffset);

				for (var ix in descIds) {
					var hfn = hFilters[descIds[ix]];
					if (nodesToSelect.indexOf(descIds[ix]) == -1 && hfn.Attr & IsVisible && hfn.Attr & IsUserEnabled)
						nodesToSelect.push(descIds[ix]);
				}
			}

			Storyboard.HFilterLayout.setSelected(nodesToSelect, treeID);
		});
	}

	function searchTree(treeID, searchText) {
		var DUITreeViewEl = $(treeID).find('.DUITreeView');
		var settings = $(DUITreeViewEl).data('DUITreeView').settings;
		var selectedNodeIDs = getTreeSelections(treeID) || [];

		if (!DUITreeViewEl.hasClass('DUITreeCompact-expanded'))
			$('.DUITreeCompactButton', $(treeID)).trigger('click');

		function search(hfilter, searchText) {
			var matches = hfilter.Attr & IsVisible && hfilter.Attr & IsUserEnabled &&
				hfilter.HFilterName.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
			var visible = matches;

			for (var childIx in hfilter.ChildNodes) {
				var childHFilter = getHFilter(hfilter.ChildNodes[childIx].toString());
				if (search(childHFilter, searchText)) {
					visible = true;
				}
			}

			if (visible) {
				delete hfilter.hiddenBySearch;
			} else {
				hfilter.hiddenBySearch = true;
			}

			if (matches) {
				hfilter.matchedBySearch = true;
			} else {
				delete hfilter.matchedBySearch;
			}

			return visible;
		}

		function setVisibility(hfilter, searchText) {
			if (hfilter.hiddenBySearch) return;

			var nodeInput = DUITreeViewEl.get(0).querySelector('input[value="' + hfilter.HFilterID + '"]');
			var node = $(nodeInput).parent();
			// make sure to expand it (will also build child nodes in time)
			if (node.length > 0 && !node.hasClass('expanded')) {
				DUITreeViewEl.DUITreeView('expandNode', node);
			}

			for (var childIx in hfilter.ChildNodes) {
				var childHFilter = getHFilter(hfilter.ChildNodes[childIx].toString());
				setVisibility(childHFilter, searchText);
			}

			if (hfilter.matchedBySearch) {
				node.attr('matchedBySearch', true);
			}
		}

		function setSelectedNodes() {
			var selNames = [];
			var to = $(treeID).children("ul");

			selectedNodeIDs.forEach(function(nodeID) {
				var nodeInput = $(treeID + " input[value='" + nodeID + "']");

				// if node already exists - set checked
				if (nodeInput.length > 0) {
					nodeInput.first().attr("checked", "checked");
				} else { // otherwise expand ancestors first
					var roots = [];
					getParentPath(nodeID, roots);
					roots = roots.reverse();

					roots.forEach(function(root) {
						to.DUITreeView('expandNode', $(document.querySelector(treeID + " input[value='" + root + "']")).parent("li"));
					});

					$(treeID + " input[value='" + nodeID + "']").first().attr("checked", "checked");
				}

				// store hfilter name
				var hfilter = getHFilter(nodeID);
				if (hfilter) selNames.push(hfilter.HFilterName);
			});

			// and display selected names in compact info
			to.DUITreeView("updateCompactText", { names: selNames });
		}

		function setVisibilityOnMatch(hfilter, searchText) {
			search(hfilter, searchText);
			setVisibility(hfilter, searchText);
			setSelectedNodes();
		}

		// Force browser to trigger reflow after changing CSS
		// in order to solve Edge issue #TFS 15649
		function reflow(element) {
			element.style.cssText += ';-webkit-transform:rotateZ(0deg)'
			element.offsetHeight
			element.style.cssText += ';-webkit-transform:none'
		}

		loadAllMissingNodes(function () {
			if (searchText.length < 1) {
				for (var nodeId in hFilters) {
					var hfn = hFilters[nodeId];
					delete hfn.matchedBySearch;
					delete hfn.hiddenBySearch;
				}
				settings.search = false;
				$('li', $(treeID))
					.removeAttr('hidden').removeAttr('matchedBySearch')
					.each(function(index, node) {
						if (index > 0 && $(node).hasClass('expanded')) {
							DUITreeViewEl.DUITreeView('expandNode', $(node));
						}
					});
			} else {
				var topNodes = getTopNodes();

				settings.search = true;
				$('li ul', $(treeID)).remove();
				$('li.expanded', $(treeID)).removeClass('expanded');

				topNodes.forEach(function(node) {
					setVisibilityOnMatch(node, searchText);
				});
				
				reflow($(treeID).get(0));
			}
		});

		DUITreeViewEl.DUITreeView('updateHeight');
	}

    // Gets ids of all ancestors up to top node
    function getParentPath(nodeID, roots) {
        for (var hfIx in hFilters)
            if (hFilters.hasOwnProperty(hfIx)) {
                var filt = hFilters[hfIx];

                if ($.inArray(parseInt(nodeID), filt.ChildNodes) > -1) {
                    roots.push(filt.HFilterID);
                    if (filt !== getTopNode())
                        getParentPath(filt.HFilterID, roots);
                    return;
                }
            }
    }

    // Gets selected hfilters ids
    // Return value should always be array
    function getSelectedIds(comp, isExport) {
        var renderType = (comp) ? containerRenderType[comp] : containerRenderType[mainTree];
        var selections;

        if (renderType === renderTypes.DROPDOWN || renderType === renderTypes.LISTBOX) {
            // export panel uses regular select box, report view uses multiselectbox
            selections = isExport ? getSelectedListBoxItemsForExport(comp) : getSelectedListBoxItems(comp);
        }
        else if (renderType === renderTypes.MULTIDROPDOWNS) {
            selections = getMultiDdlSelections(comp);
        }
        else if (renderType === renderTypes.MULTIBOXES) {
            selections = getMultiSelections(comp);
        }
        else if (renderType === renderTypes.TREE) {
            selections = getTreeSelections(comp, isExport);
        }
        else
            selections = getSelectedTreeNodes();

        resetSelections(selections);

        return selections;
    }

    // Gets a node with specified id from specified node branch
    function findNodeById(hfilterId, node) {
        if (node.HFilterID == hfilterId)
            return node;

        if (node.ChildNodes) {
            for (var i = 0; i < node.ChildNodes.length; i++) {
                if (node.ChildNodes[i]) {
                    var result = findNodeById(hfilterId, node.ChildNodes[i]);
                    if (result)
                        return result;
                }
            }
        }

        return null;
    }

    // Gets selected hfilter ids from MULTIBOXES
    function getMultiSelections(comp) {
        var tree = comp || mainTree;
        var multiSelections = [];

        // get all selections
        $(tree).find(".DUIsmartSelectBox").each(function () {
            var selectedFilters = $(this).DUIsmartSelectBox("selected");
            for (var filterIX in selectedFilters)
                if (selectedFilters.hasOwnProperty(filterIX)) {
                    multiSelections.push(selectedFilters[filterIX]);
                }
        });

        // for multiselection or advanced: only lowest selected in branch should be used, remove parents
        if (IsMultiSelect || IsAdvanced)
            multiSelections = removeParentsIfChildIsSelected(multiSelections);

        return multiSelections;
    }

    // Gets selected hfilter ids from tree control
    function getTreeSelections(comp, isExport) {
        var tree = comp || mainTree, selection, cv, i;
        var jTree = $(tree).find(".DUITreeView");

        function tsFetch() {
            var items = [];
            jTree.each(function () {
                cv = $(this).DUITreeView("getCheckedValues", { rootElement: $(this) });
                for (i in cv)
                    if (cv.hasOwnProperty(i))
                        items.push(cv[i]);
            });
            return items;
        }

        selection = tsFetch();

        if (selection.length < 1 && !isExport) {
            if (typeof jTree.attr("data-initselected") !== "undefined" && jTree.attr("data-initselected") != '') {
                selection = jTree.attr("data-initselected").split(",");
            }
        }

        return selection;
    }

    // Resets hfilter IsDefaultSelected attributes to match specified selections
    function resetSelections(selections) {
        for (var hFilterIX in hFilters)
            if (hFilters.hasOwnProperty(hFilterIX)) {

                if (hFilters[hFilterIX].Attr & IsDefaultSelected)
                    hFilters[hFilterIX].Attr &= ~IsDefaultSelected;

                for (var selectedID in selections)
                    if (selections.hasOwnProperty(selectedID)) {
                        if (hFilters[hFilterIX].HFilterID == selections[selectedID]) {
                            hFilters[hFilterIX].Attr |= IsDefaultSelected;
                        }
                    }
            }
    }

    // Gets selected hfilter nodes
    function getSelectedNodes(comp) {
        var selectedIds = getSelectedIds(comp);
        var selectedNodes = [], ix;

        for (ix = 0; ix < selectedIds.length; ix++)
            selectedNodes.push(findNodeById(selectedIds[ix], getTopNode()));

        return selectedNodes;
    }

    // Gets selected hfilter ids from MULTIDROPDOWNS
    function getMultiDdlSelections(comp) {
        var selectedItems = [];
        var tree = comp || mainTree;

        // for Multi or Advanced - get all lowest non-Navigation options
        if (IsMultiSelect || IsAdvanced) {
            // use regular multiselectbox function for Multi
            if (IsMultiSelect)
                selectedItems = getSelectedListBoxItems(comp);
            else
                $(tree + " select").each(function () {
                    var ddlLevel = parseInt($(this).attr("filterLevel"), 10);

                    // for Advanced make sure to not include Navigation nodes
                    if (!levelModeEquals(ddlLevel, levelModes.Navigation)) {
                        $(this).multiselect("getChecked").map(function () { if (this.value != 0) selectedItems.push(this.value); }).get();
                    }
                });

            // get only lowest in branch
            selectedItems = removeParentsIfChildIsSelected(selectedItems);
        } else {
            // for Single get lowest selected option
            var maxLevel = 0;

            // find lowest level with something selected
            $(tree + " select").each(function () {
                var ddlLevel = parseInt($(this).attr("filterLevel"), 10);
                var selectedLevelValue = [];
                // skip No Selection
                $(this).multiselect("getChecked").map(function () { if (this.value != 0) selectedLevelValue.push(this.value); }).get();
                if (selectedLevelValue.length > 0)
                    maxLevel = maxLevel > ddlLevel ? maxLevel : ddlLevel;
            });

            // and get selection from this dropdown
            if (maxLevel > 0)
                $(tree + " select[filterLevel='" + maxLevel + "']").multiselect("getChecked").map(function() {
                    if (this.value != 0) selectedItems.push(this.value);
                }).get();
        }

        return selectedItems;
    }

    // Checks if any id in selectedIds belongs to parentId-hfilter descendant
    function isDescendantSelected(selectedIds, parentId) {
        var parentFilter = getHFilter(parentId);

        if (parentFilter)
            for (var i in parentFilter.ChildNodes)
                if (parentFilter.ChildNodes.hasOwnProperty(i)) {
                    var sChildId = parentFilter.ChildNodes[i].toString();
                    if ($.inArray(sChildId, selectedIds) > -1 || isDescendantSelected(selectedIds, sChildId))
                        return true;
                }

        return false;
    }

    // Removes filters if some of their descendants are selected (gets lowest options from each 'branch')
    function removeParentsIfChildIsSelected(selectedFiltersIds) {
        var selectedItems = [];

        for (var i in selectedFiltersIds)
            if (selectedFiltersIds.hasOwnProperty(i))
                if (!isDescendantSelected(selectedFiltersIds, selectedFiltersIds[i]))
                    selectedItems.push(selectedFiltersIds[i]);

        return selectedItems;
    }

    // Gets selected hfilter ids from export panel select box
    function getSelectedListBoxItemsForExport(comp) {
        var selectedItems = [];

        var tree = comp || mainTree;
        $(tree + " option:selected").each(function () {
            selectedItems.push(this.value);
        });

        return selectedItems;
    }

    // Gets selected hfilter ids from multiselect controls (used by DROPDOWN, LISTBOX and MULTIDROPDOWNS with Multi mode)
    function getSelectedListBoxItems(comp) {
        var selectedItems = [];

        var tree = comp || mainTree;
        $(tree + " select").each(function () {
            if (!$(this).siblings(".ui-multiselect").hasClass("navigationLevel"))
                $(this).multiselect("getChecked").map(function () { if (this.value != 0) selectedItems.push(this.value); }).get();
        });

        return selectedItems;
    }

    // Gets selected hfilter ids from hfilter tree
    function getSelectedTreeNodes() {
        var checkedNodes = $(mainTree + " :checked");

        var hfilterIds = [];
        checkedNodes.each(function () {
			var hfilterId = $(this).parent().attr("id");
			if (hfilterId)
				hfilterIds.push(hfilterId.toString().replace(HFILTER_PREFIX, ""));
        });

        return hfilterIds;
    }

    // Checks if there are any hfilter nodes
    function hasHFilterNodes() {
        return hFilters && Object.dictionarySize(hFilters) > 0;
    }

    // Initiates hfilters load for selected layout type
    function load(containerID, renderType, url, renderInvisible, showAncestors, hfilters) {
        setNoDataNodes();

        if (!url) {
            if (renderType === renderTypes.DROPDOWN || renderType === renderTypes.LISTBOX)
                url = "RHViewStoryboard.aspx/GetHFiltersForList";
            else
                url = "RHViewStoryboard.aspx/GetHFilters";
        }

        mainTree = "#" + containerID;
        containerRenderType[mainTree] = renderType;
        if (renderInvisible)
            $(mainTree).css("display", "none");

        // if possible, avoid loading again for export panel
        var isExportPanel = containerID.indexOf('downloadTree') > -1;
        var reportRenderType = containerRenderType["#hfilterTree"];
        if (isExportPanel) {
            let options = {};
            if (Storyboard.LayoutDesigner && !Storyboard.LayoutDesigner.isBulkHFilterExportEnabled())
                options.multi = Storyboard.LayoutDesigner.getHFilterSelectionMode() === Storyboard.Constants.HFilterSelectionModes.MULTIPLE;

            // Tree, single ddl and Ddl per level work fine
            if (reportRenderType === renderTypes.TREE || reportRenderType === renderTypes.MULTIDROPDOWNS || reportRenderType === renderTypes.DROPDOWN) {
                Storyboard.HFilterLayout.displayHFilter(hFilters, getHFilterTitle(), options, hasMoreNodesToLoad, maxHFilterLevel);
                return;
            }
        }

        var data = null;
        if (renderType === renderTypes.DROPDOWN || renderType === renderTypes.LISTBOX) {
            data = { startIndex: 0, forceAll: isExportPanel && reportRenderType === renderTypes.MULTIBOXES };
        }

        if (!isLoaded) {
            showAncestorsPath = showAncestors;
            isLoaded = true;
        }

        $(mainTree).empty();
        // start load
        if (!hfilters)
            Storyboard.HFilterProxy.getHFilters(url, data);
        else
            Storyboard.HFilterProxy.setHFilters(hfilters);
    }

    // Starts hfilter controls rendering
    function render(containerId, rendertype, options, hfiltersToUse) {
        mainTree = "#" + containerId;

        // clear container
        $(mainTree).children().remove();
        containerRenderType[mainTree] = rendertype;

        options = options || {};

        if (hFilters && hfiltersToUse) {
            for (var hfid in hFilters) {
                if (hFilters.hasOwnProperty(hfid)) {
                    hfiltersToUse[hfid] && (hfiltersToUse[hfid].NoData = hFilters[hfid].NoData);
                }
            }
        }

        hFilters = hfiltersToUse ? hfiltersToUse : hFilters;

        // create controls and make sure they're shown
        displayHFilter(hFilters, getHFilterTitle(), options, hasMoreNodesToLoad, maxHFilterLevel);
        $(mainTree).css("display", "");
    }

    // Gets all hfilters or hfilters with ids from selectedFilterIDs
    function getHFilters(selectedFilterIDs) {
        if (!selectedFilterIDs)
            return hFilters;
        else {
            var selectedHFilters = [];
            if (Array.isArray(selectedFilterIDs)) {
                for (let i = 0; i < selectedFilterIDs.length; i++) {
                    for (var index in hFilters) {
                        if (selectedFilterIDs[i] == hFilters[index].HFilterID) {
                            selectedHFilters.push(hFilters[index]);
                            break;
                        }
                    }
                }
            }
            else {
                for (var index1 in hFilters) {
                    if (selectedFilterIDs == hFilters[index1].HFilterID) {
                        selectedHFilters.push(hFilters[index1]);
                        break;
                    }
                }
            }
        }

        return selectedHFilters;
    }

    // Get hfilter by id
    function getHFilter(selectedFilterID) {
        if (hFilters[selectedFilterID] && hFilters[selectedFilterID].HFilterID == selectedFilterID)
            return hFilters[selectedFilterID];

        return null;
    }

    function isMultiSelect(containerID) {
        return containerRenderType[containerID] === renderTypes.MULTIBOXES || containerRenderType[containerID] === renderTypes.TREE &&
            !$("#hfilterTree").children(".DUITreeView").hasClass("DUITreeViewSingleSelection");
	}

	function loadAllMissingNodes(callback) {
		if (hasMoreNodesToLoad) {
			var loadedIds = [];
			for (var nodeId in hFilters)
				loadedIds.push(nodeId);

			Helpers.perfJSonCall({
				method: "GetMissingHFilters",
				data: { exceptIds: loadedIds },
				message: "Loading...",
				successCallback: function (loadedHFilters) {
					for (var hf in loadedHFilters) {
						if (loadedHFilters.hasOwnProperty(hf))
							hFilters[hf] = loadedHFilters[hf];
					}
					hasMoreNodesToLoad = false;

					if (callback) callback();
				}
			});
		} else if (callback) callback();
	}

	function selectAllNodes(select, containerId, expandNodes) {
		if (expandNodes) {
			loadAllMissingNodes(function () {
				var nodeIds = [];
				if (select)
					for (var nodeId in hFilters) {
						var hfn = hFilters[nodeId];
						if (hfn.Attr & IsVisible && hfn.Attr & IsUserEnabled)
							nodeIds.push(nodeId);
					}

				Storyboard.HFilterLayout.setSelected(nodeIds);
			});
			return;
		}

        var selectedNames = [];
        if (select) {
            $(containerId + " li:not([hidden]) > input[type=checkbox]:enabled").each(function() {
                $(this).attr("checked", "checked");
                selectedNames.push($(this).parent().find(" > span").text());
            });

            selectedNames.push("...");
        } else {
            $(containerId + " input[type=checkbox]").removeAttr("checked");
            selectedNames.push("");
        }

        $(containerId).children("ul").DUITreeView("updateCompactText", { names: selectedNames });
        disableEnableExportButtons();
    }

    function disableEnableExportButtons() {
        if (mainTree.startsWith("#downloadTree", 0)) {
            if (Storyboard.HFilterLayout.getSelectedIds(mainTree, true).length < 1)
                $("#downloadSelectedPowerpoint, #downloadSelectedPDF, #downloadSelectedPPTExcel, #downloadSelectedNativePPT").attr("disabled", "disabled").attr("title", "Please select at least one hierarchical filter");
            else
                $("#downloadSelectedPowerpoint, #downloadSelectedPDF, #downloadSelectedPPTExcel, #downloadSelectedNativePPT").removeAttr("disabled").removeAttr("title");
        }
    }

    function disableEnableRegularFilterIterate(mainTree) {
        const settingsControl = $('#regularFiltersPowerpoint .SettingsControl');
        const chkSelectFilterForIterate = settingsControl.find('#chkSelectFilterForIterate');
        var numberOfSelectedHfilters = $(mainTree + ' option:selected').length;
        if (numberOfSelectedHfilters > 1) {
            settingsControl.find('button').addClass('ui-state-disabled');
            chkSelectFilterForIterate.attr({ 'disabled': 'disabled', 'checked': false });
        }
        else { 
            chkSelectFilterForIterate.removeAttr('disabled');
        }
    }
    function isDynamicFilteringEnabled() {
        var reportRenderType = containerRenderType["#hfilterTree"];
        return (dynamicFiltering !== Storyboard.Constants.DynamicFilteringStatus.Off) && (reportRenderType === renderTypes.TREE || reportRenderType === renderTypes.DROPDOWN || reportRenderType === renderTypes.MULTIDROPDOWNS);
    }

    function setUpHFilterDynamicFiltering(hfilters) {
        dynamicFiltering = hfilters.DynamicFiltering;
        dynamicFilteringMoveDisabledToBottom = hfilters.DynamicFilteringMoveDisabledToBottom;

        if(dynamicFiltering !== Storyboard.Constants.DynamicFilteringStatus.Off){
            $(mainTree).addClass("dynamicFiltering").data("dynamicFiltering", dynamicFiltering).data("dynamicFilteringMoveDisabledToBottom", dynamicFilteringMoveDisabledToBottom);
        }
    }

    function performDynamicFiltering(){
        var topNode = getTopNode();

        walkTheTree(topNode, null, function(node, parent){
            if(!node)
                return true;

            // if parent produces no data than no child can
            node.NoData = (parent && parent.NoData) || (noDataHfiltersMap[node.HFilterID] ? true : false);
        });
    }

    function walkTheTree(node, parent, callback) {

        if(callback(node, parent))
            return;

        var children = node.ChildNodes;
        
        if (children) {
            for (var i = 0, length = children.length; i < length; i++) {
                walkTheTree(hFilters[children[i]], node, callback);
            }
        }

    }

    function setNoDataNodes(noDataHFilterIds){
        noDataHfiltersMap = {};
        noDataHFilterIds && noDataHFilterIds.forEach(function(hFilterId){
            noDataHfiltersMap[hFilterId] = true;
        });
    }

    function getLoadedNoDataNodes() {
        var noDataNodes = [];

        for (var nodeId in hFilters) {
            if (hFilters.hasOwnProperty(nodeId) && hFilters[nodeId].NoData) {
                noDataNodes.push(parseInt(nodeId,10))
            }
        }

        return noDataNodes;
	}

	function getFirstSelectableId() {
		for (var hfi in hFilters) {
			if (hFilters.hasOwnProperty(hfi))
				if (hFilters[hfi].Attr & IsVisible && hFilters[hfi].Attr & IsUserEnabled) {
					return hfi;
				}
		}
	}

    sb.HFilterLayout.displayHFilter = displayHFilter;
    sb.HFilterLayout.getSelectedNodes = getSelectedNodes;
    sb.HFilterLayout.getSelectedIds = getSelectedIds;
    sb.HFilterLayout.hasHFilterNodes = hasHFilterNodes;
    sb.HFilterLayout.load = load;
    sb.HFilterLayout.render = render;
	sb.HFilterLayout.getTopNode = getTopNode;
    sb.HFilterLayout.getHFilters = getHFilters;
	sb.HFilterLayout.setSelected = setSelected;
	sb.HFilterLayout.setSelectedBySelectedLevels = setSelectedBySelectedLevels;
	sb.HFilterLayout.setSelectedBySelectedSiblings = setSelectedBySelectedSiblings;
	sb.HFilterLayout.setSelectedByXLevelsDown = setSelectedByXLevelsDown;
	sb.HFilterLayout.searchTree = searchTree;
    sb.HFilterLayout.isMultiSelect = isMultiSelect;
    sb.HFilterLayout.getHFilter = getHFilter;
    sb.HFilterLayout.selectAllNodes = selectAllNodes;
    sb.HFilterLayout.isDynamicFilteringEnabled = isDynamicFilteringEnabled;
    sb.HFilterLayout.setUpHFilterDynamicFiltering = setUpHFilterDynamicFiltering;
    sb.HFilterLayout.performDynamicFiltering = performDynamicFiltering;
    sb.HFilterLayout.setNoDataNodes = setNoDataNodes;
    sb.HFilterLayout.getLoadedNoDataNodes = getLoadedNoDataNodes;
	sb.HFilterLayout.getFirstSelectableId = getFirstSelectableId;
    sb.HFilterLayout.loadMoreListOptions = loadMoreListOptions;
    sb.HFilterLayout.MainTree = (function () {
        return {
            set: function (val) { mainTree = val; },
            get: function () { return mainTree; }
        };
    }());
})(window.Storyboard = (window.Storyboard || {}));

(function (sb) {
    sb.HFilterProxy = (sb.HFilterProxy || {});

    // HFilters web call for specific layout type (url will be different)
    function getHFilters(url, data) {
        Helpers.performJSonCall(url, data, setHFilters, null, true);
    }

    // HFilter web method callback
    function setHFilters(data) {

        var hasData = data != null && Object.dictionarySize(data.HFilterNodes) > 0;

        // hide panel if necessary
        if (Storyboard.LayoutDesigner && Storyboard.LayoutDesigner.isAdmin)
            ChartSetupUI.hideHFilterPanel(hasData);
        else if (typeof (ChartSetupUI) !== "undefined")
            ChartSetupUI.hideHFilterPanel(false);

        if (!hasData)
            GeneralSettings.hideHFilterPanel(false);

        // if there are any hfilters to use
        if (data && Object.dictionarySize(data.HFilterNodes) > 0 && hasVisibleHFilters(data.HFilterNodes)) {
            var options = { multi: false, advanced: false };

            // set options
            if (Storyboard.LayoutDesigner) {
                var hfSelectMode = Storyboard.LayoutDesigner.getHFilterSelectionMode();
                switch (hfSelectMode) {
                    case Storyboard.Constants.HFilterSelectionModes.MULTIPLE:
                        options.multi = true;
                        break;
                    case Storyboard.Constants.HFilterSelectionModes.ADVANCED:
                        options.advanced = true;
                        break;
                    case Storyboard.Constants.HFilterSelectionModes.SINGLE:
                    default:
                        options.multi = false;
                        break;
                }
            }
            
            options.useCheckAllTree = data.useCheckAllTree;
            // and pass everything to build hfilter controls 
            Storyboard.HFilterLayout.displayHFilter(data.HFilterNodes, data.SettingName, options, data.HasMoreNodes, data.MaxLevel);
            if (Storyboard.LayoutControls) {
                if (!Storyboard.LayoutDesigner.useAutoUpdate)
                    Storyboard.LayoutControls.showUpdateButton();
            }
                

			if (window.ContentType < 0) {
				Storyboard.HFilterLayout.setUpHFilterDynamicFiltering(data);
			}
        }

        $(document).trigger("hFilterCallbackFinished");
    }

    // Checks if any hfilters are visible
    function hasVisibleHFilters(hfilters) {
        var IsVisible = 2;
        for (var hf in hfilters)
            if (hfilters.hasOwnProperty(hf))
                if (hfilters[hf].Attr & IsVisible)
                    return true;

        return false;
    }

    sb.HFilterProxy.getHFilters = getHFilters;
    sb.HFilterProxy.setHFilters = setHFilters;

})(window.Storyboard = (window.Storyboard || {}));

(function ($) {
    $.fn.hFilterControl = function (renderType, url, renderInvisible, hfilters) {
        if ($(this).attr("id"))
            Storyboard.HFilterLayout.load($(this).attr("id"), renderType, url, renderInvisible, true, hfilters);
    };
})(jQuery);
